'use client';

var classes = {
  "root": "m_66836ed3",
  "wrapper": "m_a5d60502",
  "body": "m_667c2793",
  "title": "m_6a03f287",
  "label": "m_698f4f23",
  "icon": "m_667f2a6a",
  "message": "m_7fa78076",
  "closeButton": "m_87f54839"
};
export { classes as default };